import Alpine from "alpinejs";

Alpine.store('notyf', {
    alertList: [],
    inDom: [],
    currentIndex: 0,

    add(text){
        this.currentIndex += 1;
        let indexCopy = this.currentIndex;
        this.alertList.push({
                type: 'info',
                status: false,
                text: text,
                index: indexCopy
            })
        this.inDom.push({index: indexCopy});

        setTimeout(
            () => {
                let alertItem = this.alertList.find(item => item.index === indexCopy);
                if (alertItem) alertItem.status = true;
            }, 100
        )

        setTimeout(
            () => {
                let alertItem = this.alertList.find(item => item.index === indexCopy);
                if (alertItem) alertItem.status = false;
            }, 5000
        )
    },

    close(index) {
        let alertItem = this.alertList.find(item => item.index === index);
        if (alertItem) alertItem.status = false;
    }
});

window.notyf = Alpine.store('notyf')